module.exports = __webpack_public_path__ + "images/product_pickle_4.bd3bb115.jpg";